import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a620fb199f1da0014518852_1787224006068_65ba1840/mhsenglish/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a620fb199f1da0014518852_1787224006068_65ba1840/mhsenglish/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a620fb199f1da0014518852_1787224006068_65ba1840/mhsenglish/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a620fb199f1da0014518852_1787224006068_65ba1840/mhsenglish/src/components/ui/AppImage.tsx");
